import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Logo
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
        


        this.setModel()

        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('Logo')
            // Add X rotation control
            this.debugFolder
                .add(this.star3.rotation, 'x')
                .name('rotation X')
                .min(0)
                .max(180)
                .step(0.01)

            // Add Y rotation control
            this.debugFolder
                .add(this.star3.rotation, 'y')
                .name('rotation Y')
                .min(0)
                .max(180)
                .step(0.01)

            // Add Z rotation control
            this.debugFolder
                .add(this.star3.rotation, 'z')
                .name('rotation Z')
                .min(0)
                .max(180)
                .step(0.01)
        }
    }

    setModel()
    {
        this.star3 = this.resources.items.logoStar3.clone()
        this.centerTri = this.resources.items.centerTri.clone()

        this.logoMaterial = new THREE.MeshBasicMaterial({
            color: 0xF7931A,
            emissive: 0xffffff,
            emissiveIntensity: 0.1,
            wireframe: true
        })
        

        this.star3.traverse((child) => {
            if(child instanceof THREE.Mesh)
            {
                child.material = this.logoMaterial
            }
        })

        this.centerTri.traverse((child) => {
            if(child instanceof THREE.Mesh)
            {
                child.material = this.logoMaterial
            }
        })

        this.star3.scale.set(80, 80, 80)
        this.star3.rotation.x = Math.PI / 2;

        this.centerTri.scale.set(80, 80, 80)
        this.centerTri.rotation.x = Math.PI / 2;


        this.star3.rotation.y = 0;
        this.star3.rotation.z = 0;
        this.centerTri.rotation.y = 0;
        this.centerTri.rotation.z = 0;
        
        this.scene.add(this.star3)
        this.scene.add(this.centerTri)
    }

    update()
    {
        const deltaTime = this.experience.time.delta
        this.star3.rotation.z -= 1 * deltaTime
        this.centerTri.rotation.z += 4 * deltaTime
    }
}